import { UhAppModal } from 'components/shared/UHAppDownloadModal';
import styles from './AppHandoffModal.module.css';

/*
 * The desktop "get the app" dialog.
 *
 * No 'use client': this is a wrapper element around a client component, so it
 * carries no interactivity of its own. The layout and type overrides live in
 * the sibling module, which explains how they reach into the shared dialog.
 */

type AppHandoffModalProps = {
  heading?: string;
  text?: string;
};

/**
 * What gets copied. The shared component defaults to ultrahuman.com, which
 * lands someone on the homepage with no way back to what they were reading;
 * this at least opens the page they came from, where the Join button does the
 * app handoff itself. The QR is unchanged — it is the app download, which is
 * what the copy above it describes.
 */
const PULSOMICS_URL = 'https://ultrahuman.com/pulsomics';

const AppHandoffModal = ({ heading, text }: AppHandoffModalProps) => (
  <div className={styles.centred}>
    <UhAppModal heading={heading} text={text} link={PULSOMICS_URL} />
  </div>
);

export default AppHandoffModal;
